package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px


val SearchBarStyle = CssStyle {
    base {
       Modifier
           .background(Theme.LightGray.rgb)
           .border(
           width = 2.px,
           style = LineStyle.Solid,
//           color = Theme.Primary.rgb
           color = Colors.Transparent
            )
           .outline(
               width = 0.px,
               style = LineStyle.None,
               color = Colors.Transparent
           )
           .transition(Transition.of(property = "border", duration = 300.ms))
    }
    focus {
        Modifier.border(
            width = 2.px,
            style = LineStyle.Solid,
            color = Theme.Primary.rgb
            )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = Colors.Transparent
            )
    }

    hover {
        Modifier.border(
            width = 2.px,
            style = LineStyle.Solid,
            color = Theme.Primary.rgb
        )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = Colors.Transparent
            )
    }


}

val SearchTextNoStyle = CssStyle {
    base {
        Modifier
            .background(Colors.Transparent)
            .border(
                width = 0.px,
                color = Colors.Transparent
            )
            .outline(
                width = 0.px,
                color = Colors.Transparent
            )
    }
    focus {
        Modifier
            .background(Colors.Transparent)
            .border(
                width = 0.px,
                color = Colors.Transparent
            )
            .outline(
                width = 0.px,
                color = Colors.Transparent
            )
    }

    hover {
        Modifier
            .background(Colors.Transparent)
            .border(
                width = 0.px,
                color = Colors.Transparent
            )
            .outline(
                width = 0.px,
                color = Colors.Transparent
            )
    }


}

val XIconStyle = CssStyle {
    base {
        Modifier
            .color(Theme.DarkGray.rgb)
    }
    hover {
        Modifier
        Modifier
            .color(Theme.Primary.rgb)
    }


}